import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/idp-education/idp-connect/he-websites/next-js/he-websites/packages/shared-components/skeleton/search-result/search-skeleton.tsx");
